import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SIZES } from '../../data/collection';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-166" data-mp="17w3rhg845p22">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16 lg:py-24" data-id="element-167" data-mp="13wl7cmo49i0a">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-168" data-mp="yuvtkz9ieq8i">
          <SectionHeading id="beneficios-title" title="Elegí el modelo. Prepará la tela. Empezá a coser." intro="Todo lo que necesitás para pasar de la idea a la máquina, ordenado por volumen y por modelo." data-id="element-169" data-mp="1vlod66vnj0f1" />
        </div>

        <ol className="divide-y divide-dashed divide-coral/35 border-y border-dashed border-coral/35" data-id="element-170" data-mp="1hnpyt1hbz3zj">
          <li className="py-8" data-id="element-171" data-mp="b7e7nkcxemdg">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-172" data-mp="b8pb1j2gls41">Ampliá tus opciones</h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-173" data-mp="6ae1l9g2tjmc">
              Vestidos, ranitas, enteritos y conjuntos para coser lo que necesitás: una prenda para estrenar, un regalo
              o tu próxima tanda para vender.
            </p>
          </li>
          <li className="py-8" data-id="element-174" data-mp="171vh8el1zd5e">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-175" data-mp="1bylw4yl4g2p8">
              Elegí el talle por estatura
            </h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-176" data-mp="x8oel1hp6b90">
              Diez talles para trabajar con distintas medidas. Los accesorios de cabeza se eligen por contorno de cabeza.
            </p>
            <ul aria-label="Talles por estatura, en centímetros" className="mt-5 flex flex-wrap gap-2" data-id="element-177" data-mp="t84htz11d9ne">
              {SIZES.map(size => <li key={size} className="flex h-10 min-w-[3rem] items-center justify-center rounded-full bg-sage-tint px-3 text-[0.95rem] font-bold tabular-nums text-sage-ink" data-id="element-178" data-mp="eceplj59c0a8">
                  {size}
                </li>)}
            </ul>
          </li>
          <li className="py-8" data-id="element-179" data-mp="3rixxfuwxxzie">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-180" data-mp="3mkwi9l2mykc7">
              Tené el molde y la guía a mano
            </h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-181" data-mp="3hnwb16u1vbji">
              Imprimí las piezas en A4, a escala real y con margen de costura de 7 mm, y seguí la confección en el
              manual desde el celular, la tablet o la compu.
            </p>
          </li>
        </ol>
      </div>
    </section>;
}